<template>
  <p class="text-right mt-2">

    <v-chip
      :color="progressColor"
      label
      small
      class="mr-2"
    >
      <span class="caption" v-if="totalItems && totalFetched">
        showing {{ totalFetched }}/{{ totalItems }}
        <span v-if="loading"> ..fetching more</span>
      </span>
      <span v-else-if="loading">
        fetching
      </span>
      <span v-else>
        no matches
      </span>
    </v-chip>
  </p>
</template>
<script>
import { getIconColor } from '@/js/store'
export default {
  props: {
    totalFetched: Number,
    totalItems: Number,
    loading: Boolean
  },
  computed: {
    progressColor () {
      return getIconColor(this.totalItems === this.totalFetched ? (this.totalItems ? 'done' : 'none') : 'progress')
    }
  }
}
</script>     
